import { render, staticRenderFns } from "./LightSwitch.vue?vue&type=template&id=1417389e&scoped=true&"
import script from "./LightSwitch.vue?vue&type=script&lang=ts&"
export * from "./LightSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LightSwitch.vue?vue&type=style&index=0&id=1417389e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1417389e",
  null
  
)

export default component.exports